<template>
  <div>
    <MyPage v-show="currentSearchState === 'view'" current="MyPage" />
    <RouteResult v-if="currentSearchState === 'result'" current="MyPage" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import MyPage from "@/components/Pages/MyPage";
import RouteResult from "@/components/Pages/RouteResult";

export default {
  name: "mypage-root",
  components: {
    MyPage,
    RouteResult,
  },
  computed: {
    ...mapState(["currentPageName", "searchState"]),
    currentSearchState() {
      return this.searchState.mypage;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MyPageRoot.vue